import $ from "jquery";
import videojs from "video.js";
import CONFIG from "@bd-core/config";
import Storage from "@bd-utils/storage";
import { getState } from "@bd-stores/store";
import GameLogic from "@bd-core/game-logic";
import BD_Component from "@bd-core/bd-component";
import compile from "@bd-utils/handlerbars-helper";
import { getRoomAnswerById } from "@bd-stores/game-data";
import {
    getRoomStatus,
    getFinalTeamAnswers,
    getRoomScore,
    getRoomLogo,
    getTotalAttempt,
    getTeamAnswers,
    getCurrentRoomScreen,
    getIsRoomTimeOut,
} from "@bd-stores/game-progress";
import {
    maybeUpdateRoomStatus,
    updateFinalRoomAnswer,
    getFinalRoomAnswers,
    updateRoomAnswer,
    getRoomAnswers,
    setTeamLogos,
    setTotalAttempt,
    setRoomTotalScores,
    updateCurrentScreen,
} from "@bd-core/firebase-actions";
import { isLeader } from "@bd-stores/game-progress";
import { isTestMode } from "@bd-utils/test-mode";

export class RoomCluesEquations extends BD_Component {
    constructor() {
        super();

        this.id = "clues_equations";
        this.templateID = "clues_equations-template";

        this.elms = {
            // narrative popup
            narrativePopup: ".js-narrative-popup",
            narrativeCloseBtn: ".js-close-narrative-popup",

            // reward screen
            rewardScreen: ".js-reward-feedback",
            rewardTitle: ".js-reward-title",
            rewardSubtitle: ".js-reward-subtitle",
            rewardDescription: ".js-reward-description",
            rewardScore: ".js-reward-score",
            rewardContinueBtn: ".js-reward-continue-btn",
            triggerRewardScreenBtn: ".btn-continue-reward-screen",

            // customization
            customizationScreen: ".js-customization",
            customRewardWrapper: ".challange-prize__item-wrapper",
            customizationContinueBtn: ".js-customization-continue-btn",
            customizationCategory: ".js-category",
            logoImage: ".js-logo",

            // puzzle
            questionItem: ".js-question-item",
            headerQuestion: ".js-header-question",
            closeBtn: ".js-cluesEquations-close",
            inputWrapper: ".js-input-wrapper",
            inputAnswer: ".js-input-answer",
            check: ".js-checking",
            continueBtn: ".js-continue-btn",

            skipVideoBtn: ".js-skip-video",
        };

        this._events = this.getEvents();

        this.userAnswer = undefined;

        this.isPlayingOnline = CONFIG.game.isPlayingOnline;

        this.introVideo = null;
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        const elms = this.elms;
        return [
            {
                event: "blur",
                selector: elms.inputAnswer,
                handler: this.onBlurInput,
            },
            {
                event: "focus",
                selector: elms.inputAnswer,
                handler: this.onInputFocus,
            },
            {
                event: "keypress",
                selector: elms.inputAnswer,
                handler: this.inputAnswer,
            },
            {
                event: "click",
                selector: elms.check,
                handler: this.checkAnswer,
            },
            {
                event: "click",
                selector: elms.continueBtn,
                handler: this.maybeRoomIsFinish,
            },
            {
                event: "click",
                selector: elms.triggerRewardScreenBtn,
                handler: this.goToRewardScreen,
            },
            {
                event: "click",
                selector: elms.rewardContinueBtn,
                handler: this.goToCustomizationScreen,
            },
            {
                event: "click",
                selector: elms.customizationContinueBtn,
                handler: this.setSelectedLogo,
            },
            {
                event: "click",
                selector: elms.narrativeCloseBtn,
                handler: this.closeNarrativePopup,
            },
            {
                event: "click",
                selector: elms.skipVideoBtn,
                handler: this.skipIntroVideo,
            },
        ];
    }

    beforeInit() {
        this.render();
        this.setGameState();
        this.setupSlider();
        this.setTestMode();
    }

    getModifiedData() {
        const isTeamLeader = isLeader();
        const roomData = this._data;
        const modifiedData = {
            ...roomData,
            isLeader: isTeamLeader,
        };

        return modifiedData;
    }

    render() {
        const roomData = this.getModifiedData();
        const htmlTemplate = $("#" + this.templateID).html();
        const html = compile(htmlTemplate, roomData);
        $(".app").html(html);
    }

    setTestMode() {
        if (isTestMode()) {
            $(".app__page").addClass("is-room-completed");
            this.switchNextStep();
            $(".app__back").removeClass("hidden");
        }
    }

    setGameState() {
        const roomId = this.roomId;
        const thisRoomStatus = getRoomStatus(roomId);

        /**
         * @type {BD_RoomCluesEquationsFinalAnswer}
         */
        const teamAnswers = getFinalTeamAnswers(roomId);
        const self = this;
        const elms = self.elms;

        const possibleStatuses = [
            "is-status-open",
            "is-status-started",
            "is-status-completed",
        ];

        if (thisRoomStatus) {
            const $status = $(".js-room-status");
            $status.removeClass(possibleStatuses);
            $status.addClass(thisRoomStatus);
        }

        const setAnswers = (answers) => {
            $.each(answers, function (questionID, item) {
                let theAnswer, theStatus;

                if (typeof item === "object") {
                    const { answer, isCorrect } = item;
                    theAnswer = answer;
                    theStatus = isCorrect;
                } else {
                    theAnswer = item;
                }

                const $wrapper = $(
                    elms.questionItem + `[data-id="${String(questionID)}"]`,
                );

                [...theAnswer].forEach(function (value, index) {
                    $wrapper
                        .find(elms.inputAnswer)
                        .eq(index)
                        .prop("readonly", true)
                        .val(value);
                    // $wrapper
                    //     .find(elms.inputAnswer)
                    //     .eq(index)
                    //     .next()
                    //     .text(value);
                });

                if (theStatus !== undefined && !theStatus) {
                    self.numberWrong(questionID);
                } else {
                    self.numberCorrect(questionID);
                }
            });
        };

        if (thisRoomStatus === "is-status-completed") {
            setAnswers(teamAnswers);
            $(".app__page").addClass("is-room-completed");
            this.switchNextStep();
        } else {
            const roomAnswers = getTeamAnswers(roomId);
            setAnswers(roomAnswers);
            this.switchNextStep();
        }

        /* force players to be on the same screen */
        const currentScreen = getCurrentRoomScreen(roomId);

        switch (currentScreen) {
            // case "search-find":
            //     $(".narrative-layer").show();
            //     $(".search-and-find-bg").show();
            //     break;
            case "video-intro":
                this.playIntroVideo();
                break;
            case "reward-screen":
                this.goToRewardScreen();
                break;
            case "customisations-screen":
                this.goToCustomizationScreen();
                break;
            case "puzzle-screen":
                if (this.introVideo && this.introVideo.length > 0) {
                    this.introVideo.trigger("ended");
                }

                $(".narrative-layer .screen .screen__inner").addClass("enter");
                setTimeout(() => {
                    $(".narrative-layer").css({
                        opacity: 0,
                        "pointer-events": "none",
                    });
                }, 500);
                this.handleBriefingPopup();
                $(".videobox").removeClass("is-open");
                $(elms.rewardScreen).removeClass("active");
                $(elms.customizationScreen).removeClass("active");
                break;
            default:
            //
        }
        /* END: force players to be on the same screen */

        const isRoomTimeout = getIsRoomTimeOut(roomId);
        if (isRoomTimeout && isLeader()) {
            $(elms.continueBtn).removeClass("disabled");
            $(elms.continueBtn).removeAttr("disabled");
        }
    }

    // ============================== CUSTOM FUNCTION

    handleBriefingPopup() {
        let roomId = this.roomId;

        // fix https://www.pivotaltracker.com/story/show/186872215
        if (!isNaN(parseInt(roomId.toString()))) {
            roomId = parseInt(roomId.toString());
        }

        let states = Storage.get("states", {});
        if (!states?.briefing) states.briefing = [];

        if (!states.briefing.includes(roomId)) {
            GameLogic.toggleBriefing();
        }
    }

    inputAnswer(e, el) {
        e.preventDefault();
        // const is_leader = this.isTeamLeader;
        const is_leader = isLeader();
        if (!is_leader) return;

        const $el = $(el);
        const elms = this.elms;
        const $questionWrapper = $el.parents(elms.questionItem);
        const questionID = $questionWrapper.attr("data-id");

        if ($questionWrapper.hasClass("is-completed")) {
            return false;
        }

        const allowedChar = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

        if (
            allowedChar.indexOf(e.key) === -1 ||
            $el.parents(".number-content").hasClass("correct")
        ) {
            return false;
        }

        const value = String($el.val(e.key));
        const $nextInput = $el.next();

        if (value.trim() !== "" && $nextInput.length) {
            $el.trigger("blur");
            $nextInput.trigger("focus");
        }

        this.checkAnswer(questionID);
    }

    checkAnswer(questionId) {
        const elms = this.elms;
        const $questionItem = $(`
            ${elms.questionItem}[data-id="${questionId}"]
        `);
        const $answers = $questionItem.find(elms.inputAnswer);

        const roomId = this.roomId;
        const currentRoomStatus = getRoomStatus(roomId);
        const completedStatus = "is-status-completed";
        if (currentRoomStatus === completedStatus) {
            this.goToRewardScreen();
            return;
        }

        const roomAnswers = getRoomAnswerById(roomId);
        let totalAttempt = getTotalAttempt(roomId);
        let roomStatus = "is-status-started";
        let isAllAnswered = true;
        let isCorrect = false;
        let playerAnswer = "";

        $.each($answers, function (index, answer) {
            const answerValue = String($(answer).val()).trim();

            if (answerValue === "") {
                isAllAnswered = false;
                return false;
            }

            playerAnswer += answerValue;
        });

        if (!isAllAnswered) return;

        this.showLoading(questionId);

        const gameVersion = this.isPlayingOnline ? "virtual" : "physical";
        const correctAnswer = roomAnswers?.[questionId]?.[gameVersion] || false;

        playerAnswer = playerAnswer.toLowerCase();

        if (playerAnswer === correctAnswer) isCorrect = true;

        const updateData = {
            [questionId]: playerAnswer,
        };

        totalAttempt++;
        setTotalAttempt(roomId, totalAttempt);

        if (isCorrect) {
            maybeUpdateRoomStatus(roomId, roomStatus);
            this.numberCorrect(questionId);

            const onSuccessUpdate = () => {
                $answers.prop("readonly", true);
                // this.maybeRoomIsFinish.call(this);
            };

            const onErrorUpdate = () => {};

            updateFinalRoomAnswer(roomId, updateData)
                .then(onSuccessUpdate)
                .catch(onErrorUpdate);
        } else {
            this.numberWrong(questionId);
            maybeUpdateRoomStatus(roomId, roomStatus);
        }

        this.userAnswer = {
            [questionId]: {
                answer: playerAnswer,
                isCorrect: isCorrect,
            },
        };

        this.updateUserAnswer();
        this.switchNextStep();
    }

    showLoading(questionID) {
        const elms = this.elms;
        const $questionItem = $(`${elms.questionItem}[data-id=${questionID}]`);
        $questionItem.find(elms.check).removeClass("hidden");
    }

    hideLoading(questionID) {
        const elms = this.elms;
        const $questionItem = $(`${elms.questionItem}[data-id=${questionID}]`);
        $questionItem.find(elms.check).addClass("hidden");
    }

    numberCorrect(questionID) {
        const elms = this.elms;
        const $questionItem = $(
            `${elms.questionItem}[data-id="${questionID}"]`,
        );
        const $answers = $questionItem.find(elms.inputAnswer);

        this.hideLoading(questionID);
        this.switchHeaderIcon(questionID, "correct"); // show bars icon and hide locked icon
        this.switchWrapperClass(questionID, "correct");
        this.switchNumberClass(questionID, "correct");

        $answers.prop("readonly", true);

        // check is all number on each block has been filled with correct answer
        // this.switchNextStep('correct');
    }

    numberWrong(questionID) {
        const elms = this.elms;
        const $questionItem = $(
            `${elms.questionItem}[data-id="${questionID}"]`,
        );
        const $answers = $questionItem.find(elms.inputAnswer);

        this.hideLoading(questionID);
        this.switchHeaderIcon(questionID, "wrong"); // show bars icon and hide locked icon
        this.switchWrapperClass(questionID, "wrong");
        // this.switchNumberClass(questionID, "wrong");

        setTimeout(() => {
            const isCurrentCorrect = $questionItem.hasClass("correct");

            if (!isCurrentCorrect) {
                $answers.prop("readonly", false);
                $answers.val("");
                $answers.first().trigger("focus");
            }
        }, 500);

        // check is all number on each block has been filled with correct answer
        // this.switchNextStep('correct');
    }

    switchHeaderIcon(questionID, type) {
        const elms = this.elms;
        const $questionItem = $(
            `${elms.questionItem}[data-id="${questionID}"]`,
        );
        const $header = $questionItem.find(elms.headerQuestion);

        if (type === "correct") {
            // show bars icon, hide locked icon
            $header.find(".locked").addClass("hidden");
            $header.find(".unlocked").removeClass("hidden");
        } else {
            // hide bars icon, show lock icon
            $header.find(".unlocked").addClass("hidden");
            $header.find(".locked").removeClass("hidden");
        }
    }

    switchWrapperClass(questionID, type) {
        const elms = this.elms;
        const $questionItem = $(
            `${elms.questionItem}[data-id="${questionID}"]`,
        );

        if (type == "correct") {
            $questionItem.removeClass("locked");
            $questionItem.removeClass("wrong");
            $questionItem.addClass("correct");
        } else {
            $questionItem.removeClass("correct");
            $questionItem.addClass("wrong");
            $questionItem.addClass("locked");
        }
    }

    switchNumberClass(questionID, type, stay) {
        const elms = this.elms;
        const $questionItem = $(
            `${elms.questionItem}[data-id="${questionID}"]`,
        );
        const $inputWrapper = $questionItem.find(elms.inputWrapper);

        if (type == "correct") {
            $inputWrapper.addClass("correct");

            if (stay) {
                return false;
            }

            const $activeSlick = $(".slick-active");
            const $activeSlickItem = $activeSlick.find(elms.questionItem);
            const isActiveSlickCorrect = $activeSlickItem.hasClass("correct");

            if (isActiveSlickCorrect)
                $(".keyquestion__nav-item.nav-right").trigger("click");
        } else {
            $inputWrapper.addClass("wrong");
        }
    }

    switchNextStep() {
        const elms = this.elms;
        const $questions = $(elms.questionItem);
        const $nextStep = $(elms.continueBtn);
        let isAllCorrect = true;

        $.each($questions, function (index, item) {
            const isCorrect = $(item).hasClass("correct");
            if (!isCorrect) return (isAllCorrect = isCorrect);
        });

        // enable next step
        if (isAllCorrect || isTestMode()) {
            $nextStep.removeClass("disabled");
            $nextStep.removeAttr("disabled");
        } else {
            $nextStep.addClass("disabled");
            $nextStep.attr("disabled", "disabled");
        }
    }

    resetNumberClass(questionID) {
        const elms = this.elms;
        const $questionItem = $(
            `${elms.questionItem}[data-id="${questionID}"]`,
        );
        const $inputWrapper = $questionItem.find(elms.inputWrapper);

        $inputWrapper.removeClass("correct wrong");
    }

    calculateScore(totalAttempt) {
        const rewards = this._data.point_earned || [];
        const score = 10;
        // @ts-ignore
        const reward = rewards.find((item) => {
            const level = item.level;
            const attempts = item.total_attempts;

            if (level === "below") {
                return totalAttempt <= attempts;
            }

            if (level === "above") {
                return totalAttempt >= attempts;
            }
        });

        return Number(reward?.points) || score;
    }

    maybeRoomIsFinish() {
        const roomId = this.roomId;
        const total_attempts = getTotalAttempt(roomId);

        getFinalRoomAnswers(roomId).then((data) => {
            const roomAnswers = getRoomAnswerById(roomId);
            const fbRoomAnswers = data.val();
            const isRoomTimeout = getIsRoomTimeOut(roomId);

            if (
                ((!fbRoomAnswers && !isRoomTimeout) ||
                    typeof roomAnswers !== "object" ||
                    typeof fbRoomAnswers !== "object") &&
                !isRoomTimeout &&
                !isTestMode()
            ) {
                return;
            }

            if (isRoomTimeout) {
                const score = 0;
                setRoomTotalScores(roomId, score);
                this.goToRewardScreen();
            }

            if (isTestMode()) {
                const score = 0;
                setRoomTotalScores(roomId, score);
                maybeUpdateRoomStatus(roomId, "is-status-completed");
                this.goToRewardScreen();
            }

            if (
                !isTestMode() &&
                Object.keys(roomAnswers).length ==
                    Object.keys(fbRoomAnswers).length
            ) {
                const score = this.calculateScore(total_attempts);
                setRoomTotalScores(roomId, score);
                maybeUpdateRoomStatus(roomId, "is-status-completed")
                    .then(() => {
                        /**
                         * check if completion popup text is empty
                         * if empty, go to reward screen directly
                         * if has content, the content is appeared (see GameLogic)
                         */
                        const roomData = this._data;
                        const { completion_popup } = roomData;
                        const { title, content } = completion_popup;

                        if (!title && !content) this.goToRewardScreen();
                    })
                    .catch();
            }
        });
    }

    onBlurInput(e) {
        let $this = $(e.currentTarget);
        let val = String($this.val());
        let display = $this.next();

        display.removeClass("on-input");
        display.text(val.trim());
    }

    onInputFocus(e) {
        const $this = $(e.currentTarget);
        const $display = $this.next();
        const val = String($this.val());

        $this.removeAttr("readonly");
        $display.addClass("on-input");

        if (val.trim() === "") {
            $display.text("");
        }

        if (val.trim().length) {
            $this[0].setSelectionRange(val.length - 1, val.length);
        }
    }

    updateUserAnswer() {
        const roomId = this.roomId;

        getRoomAnswers(roomId).then((data) => {
            const fbRoomAnswers = data.val() ?? {};
            const answer = this.userAnswer;
            const answerData = { ...fbRoomAnswers, ...answer };

            updateRoomAnswer(roomId, answerData);
        });
    }

    updateUserChoicesList(answer) {
        if ($("#locationInfo-item").length < 1) return;

        const fbRoomAnswers = answer.val() ?? {};
        const players = getState().gameProgress.players;
        const template = $("#locationInfo-item").html();

        // Filter the player to not include the current user
        const onlinePlayers = players.filter(
            (player) => player.isOnline && player.userId !== CONFIG.user.id,
        );

        $(".userChoice_list").each(function () {
            const $context = $(this).parents(".js-userChoices-context");
            const hasContext = $context.length > 0;

            const questionID = hasContext
                ? $context.attr("data-question-id")
                : undefined;

            const users = onlinePlayers.filter((player) => {
                //console.log('player', player)
                const usrID = player.userId;
                const thisPlayerAnswer = fbRoomAnswers[usrID]?.choice;

                if (typeof thisPlayerAnswer !== "object") {
                    return;
                }

                if (thisPlayerAnswer[questionID]) {
                    const answer = thisPlayerAnswer[questionID].answer;
                    const user = {
                        ...player,
                        answer: answer,
                    };

                    return user;
                }
            });

            const html = compile(template, { players: users });
            $(this).html(html);
        });
    }
    /* show feedback reward screen */
    goToRewardScreen() {
        const elms = this.elms;
        const roomId = this.roomId;
        const rewards = this._data.rewards || [];
        const roomScore = getRoomScore(roomId);
        const $rewardPopup = $(elms.rewardScreen);
        const teamname = CONFIG.game.teamname;
        const is_leader = isLeader();
        const $completionPopUp = $(".js-room-completion");

        // @ts-ignore
        const reward = rewards.find((item) => roomScore == Number(item.points));

        let title, subtitle, description;

        if (reward?.title) {
            title = reward.title;
            title = title.replaceAll("{team_name}", teamname);
        }

        if (reward?.subtitle) subtitle = reward.subtitle;

        if (reward?.description) description = reward.description;

        $completionPopUp.removeClass("is-open");

        $rewardPopup.addClass("active");
        $rewardPopup.find(elms.rewardTitle).text(title);
        $rewardPopup.find(elms.rewardSubtitle).text(subtitle);
        $rewardPopup.find(elms.rewardDescription).html(description);
        $rewardPopup.find(elms.rewardScore).text(roomScore);

        if (is_leader) updateCurrentScreen(roomId, "reward-screen");

        // hide timer hint popup
        $(".js-popup-timerhint").removeClass("is-open");
    }

    /* show customization screen */
    goToCustomizationScreen() {
        const elms = this.elms;
        const roomId = this.roomId;
        const is_leader = isLeader();
        const roomScore = getRoomScore(roomId);
        const $rewardPopup = $(elms.rewardScreen);
        const $customizationPopup = $(elms.customizationScreen);
        const $score = $(elms.rewardScore);
        const $selectedCategory = $(`
            ${elms.customizationCategory}[data-score="${roomScore}"]
        `);

        $(elms.customizationCategory).each(function () {
            const $slider = $(this).find(".challange-prize__item-wrapper");
            const isInitialized = $slider.hasClass("slick-initialized");
            const sliderCustomRewardOption = {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                dots: false,
                arrows: true,
                prevArrow: $(this).find(`.challange-prize__item-prev`),
                nextArrow: $(this).find(`.challange-prize__item-next`),
            };

            if (!isInitialized) $slider.slick(sliderCustomRewardOption);
        });

        $selectedCategory.addClass("is-selected");
        $rewardPopup.removeClass("active");
        $customizationPopup.addClass("active");
        $score.text(roomScore);

        if (is_leader) updateCurrentScreen(roomId, "customisations-screen");
    }

    setSelectedLogo() {
        const elms = this.elms;
        const roomId = this.roomId;
        const is_leader = isLeader();
        const roomLogo = getRoomLogo(roomId);
        const roomScore = getRoomScore(roomId);
        const $selectedCategory = $(`
            ${elms.customizationCategory}[data-score="${roomScore}"]
        `);
        const $activeSlide = $selectedCategory.find(".slick-active");
        const $theImg = $activeSlide.find(elms.logoImage);
        const selectedImg = $theImg.attr("data-image");

        // redirect player to mainroom
        const goToMainroom = () => {
            const mainRoomID = CONFIG?.game?.rooms.find(
                (key) => key.id == roomId,
            ).mainroom_id;

            if (is_leader) updateCurrentScreen(roomId, null);
            GameLogic.goToPage(mainRoomID);
        };

        if (roomLogo) goToMainroom();

        if (selectedImg == undefined) {
            goToMainroom();
            return false;
        }

        if (is_leader) {
            setTeamLogos(roomId, selectedImg)
                .then(goToMainroom)
                .catch(goToMainroom);
        } else {
            goToMainroom();
        }
    }

    setupSlider() {
        const sliderSourcePopup = {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: true,
            customPaging: function (slider, i) {
                return "<a>" + (i + 1) + "</a>";
            },
            appendDots: $(".source-popup__nav-item.nav-pagination"),
            prevArrow: $(".source-popup__nav-item.nav-left"),
            nextArrow: $(".source-popup__nav-item.nav-right"),
        };

        const sliderInfoPopup = {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: true,
            customPaging: function (slider, i) {
                return "<a>" + (i + 1) + "</a>";
            },
            appendDots: $(".msn-popup__nav-item.nav-pagination"),
            prevArrow: $(".msn-popup__nav-item.nav-left"),
            nextArrow: $(".msn-popup__nav-item.nav-right"),
        };

        const slickGame = {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: false,

            prevArrow: $(".keyquestion__nav-item.nav-left"),
            nextArrow: $(".keyquestion__nav-item.nav-right"),
        };

        $("#keyquestion-list").slick(slickGame);

        $(".js-source-wrapper").slick(sliderSourcePopup);
        $(".js-info-slider-wrapper").slick(sliderInfoPopup);
        $(".js-source-wrapper").slick("refresh");
        $(".js-info-slider-wrapper").slick("refresh");
    }

    skipIntroVideo() {
        const videos = videojs.getPlayers();
        const introVideo = videos["intro-video-clues-equations"];

        introVideo.dispose();
        this.afterPlayIntroVideo();
    }

    afterPlayIntroVideo() {
        const $introVideo = $(".videobox");
        const is_leader = isLeader();

        let states = Storage.get("states", {});
        let introStates = states?.introVideo || [];

        $introVideo.removeClass("is-open");

        introStates.push(this.roomId);
        states.introVideo = introStates;
        Storage.set("states", states);

        if (is_leader) updateCurrentScreen(this.roomId, "puzzle-screen");
    }

    /* play intro video */
    playIntroVideo() {
        const $introVideo = $(".videobox");
        const $narrativePopup = $(".js-narrative-popup");
        const introVideoUrl = this._data.video_block.video_intro;
        const is_leader = isLeader();

        $narrativePopup.removeClass("is-open");

        if (!$introVideo.length) return false;

        let states = Storage.get("states", {});
        let introStates = states?.introVideo || [];

        /**
         * check wheiter the video has url or not
         * if no url, close video popup
         **/
        if (introVideoUrl === "false") {
            $introVideo.removeClass("is-open");
            return false;
        }
        const self = this;
        if (!introStates.includes(this.roomId)) {
            // init video js with full screen
            self.introVideo = videojs("intro-video-clues-equations", {
                controls: true,
                autoplay: true,
                preload: "auto",
                sources: [
                    {
                        src: introVideoUrl,
                        type: "video/mp4",
                    },
                ],
                techOrder: ["html5"],
            });

            // handle on ended video
            self.introVideo.on("ended", () => {
                if (self.introVideo) {
                    self.introVideo.dispose();
                }

                this.afterPlayIntroVideo();
            });

            // handle on error video
            self.introVideo.on("error", function () {
                console.error("Can't play the video");
            });

            $introVideo.addClass("is-open");
            if (is_leader) updateCurrentScreen(this.roomId, "video-intro");

            try {
                self.introVideo.play().catch((error) => {
                    // Autoplay was blocked. Do something
                    console.error("Unable to start auto play", error);
                    if (is_leader)
                        updateCurrentScreen(this.roomId, "puzzle-screen");
                });
            } catch (error) {
                console.error(error);

                if (is_leader)
                    updateCurrentScreen(this.roomId, "puzzle-screen");
            }
        } else {
            $introVideo.removeClass("is-open");
        }
    }

    closeNarrativePopup() {
        GameLogic.toggleNarrative();

        this.playIntroVideo();
    }
}
